/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
const eventAggregator = require('js/app/core/event-aggregator');

module.exports = eventAggregator;
